import React, { useState, useEffect, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import constants from "../../../utils/constants";
import TrashIcon from '../../../assets/icons/table/trash.svg';

function AddFiles(props) {
  const {
    setSuccess,
    setError,
    closeModal,
    loadTable,
    fetchFolderTreeData,
    dataMap,
    handleAddFile,
    checkStorageCapacityBySiteId,
    selectedKey,
    checkedKey
  } = props;

  const [selectedFiles, setSelectedFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [modalError, setModalError] = useState('');
  const [refreshing, setRefreshing] = useState(false);

  const intl = useIntl();

  const chooseFileText = intl.formatMessage({ id: 'MES_CHOOSE_FILE_TEXT' });
  const modalId = 'addFilesModal';

  useEffect(() => {
    const modal = document.getElementById(modalId);
    
    if (modal) {
      const handleModalShow = () => {
        resetModal();
      };
      
      const handleModalHidden = () => {
       resetModal();
      };
      
      modal.addEventListener('show.bs.modal', handleModalShow);
      modal.addEventListener('hidden.bs.modal', handleModalHidden);
      
      return () => {
        modal.removeEventListener('show.bs.modal', handleModalShow);
        modal.removeEventListener('hidden.bs.modal', handleModalHidden);
      };
    }
  }, []);

  const resetModal = () => {
    setSelectedFiles([]);
    fileInputRef.current.value = null;
    setModalError('');
    setRefreshing(false);
  };

  useEffect(() => {
    const checkFiles = async () => {
      await checkFileSupported();
    };
    checkFiles();
  }, [selectedFiles]);

  function handleFileSelection(file) {
    if (file === undefined) return;
    if(refreshing){
      setError(<FormattedMessage id="PLEASE_WAIT_FOR_PREVIOUS_UPLOAD" />);
      return;
    }
    setSelectedFiles(prevFiles => [...prevFiles, ...file]);
  }

  function removeFile(e, file) {
    e.stopPropagation();
    setSelectedFiles(selectedFiles.filter(f => f !== file));
    fileInputRef.current.value = null;
  }

  function openFileDialog(e) {
    e.stopPropagation();
    document.getElementById('filesFormFile').click();
  }

  async function checkFileSupported(){
    let filesSupported = true;
    let filesSize = 0;
    if (selectedFiles.length > 0){
      for(let i=0; i < selectedFiles.length; i++){
        const fileName = selectedFiles[i].name;
        const fileExtension = fileName.split('.').pop().toLowerCase();
        filesSize += selectedFiles[i].size;
        if (!['jpg', 'jpeg', 'png', 'gif', /*'mp4','pptx',*/  'pdf'].includes(fileExtension)) {
          filesSupported = false;
        }
      }
      if(!filesSupported){
        setModalError(<FormattedMessage id="FILE_TYPE_NOT_SUPPORTED" />);
      }else{
        const hasStorageSpace = await checkStorageCapacityBySiteId(filesSize);
        if(!hasStorageSpace){
          setModalError(<FormattedMessage id="INSUFFICIENT_STORAGE_SPACE" />);
          return false;
        }else{
          setModalError('');
        }
      }
    }
    return filesSupported;
  }

  async function handleUpload() {
    if (selectedFiles.length > 0) {
      try {
        const filesSupported = await checkFileSupported();
        if(!filesSupported){
          return;
        }
        const uploadFilesObj = [];       
        selectedFiles.forEach(file => {
          const fileName = file.name;
          const fileExtension = fileName.split('.').pop().toLowerCase();

          if (['jpg', 'jpeg', 'png', 'gif', /*'mp4', 'pptx',*/ 'pdf'].includes(fileExtension)) {
            /*uploadFilesObj.push( {
              name: fileName.substring(0, fileName.lastIndexOf('.')),
              category: constants.SIGNAGE_MEDIA.MEDIA_CATEGORY.MEDIA,
              subcategory: constants.SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.FILE,
              type: fileExtension,//fileExtension === 'mp4' ? 'video' : 'image',
              parentId: checkedKey[0],
              size: `${file.size}`,//`${(selectedFile.size / 1024).toFixed(2)}`, // size in KB
              uploadFile: file
            });*/
            uploadFilesObj.push(file);
          } else {
            //setModalError(<FormattedMessage id="INVALID_FILE_EXTENSION" values={{ extension: fileExtension }} />);
            setModalError(<FormattedMessage id="FILE_TYPE_NOT_SUPPORTED" />);
          }
        });
        if (uploadFilesObj.length > 0) {          
          setRefreshing(true);
          await handleAddFile(uploadFilesObj);
          setRefreshing(false);
          closeModal("addFilesModal");
          resetModal();          
        }
      } catch (err) {
        setModalError(<FormattedMessage id="UPLOAD_FILE_FAILED" values={{ errorMsg: err.message }} />);
        console.error(err);
      }
    } else {
      setModalError(<FormattedMessage id="PLEASE_SELECT_FILE" />);
    }
  }

  function handleDrop(e) {
    e.preventDefault();
    //const file = e.dataTransfer.files[0];
    handleFileSelection(e.dataTransfer.files);
  }

  return (
    <div className="modal modal-mse fade" id="addFilesModal" tabIndex="-1" aria-labelledby="addFilesModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-mes-content">
          <div className="modal-header modal-mes-header" style={{ backgroundColor: '#347BFA' }}>
            <h5 className="modal-title modal-mes-title"><FormattedMessage id="ADD_FILES" /></h5>
            <button id="closeImportModal" type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="font-weight-600 fz-20 mb-3"><FormattedMessage id="UPLOAD_FILE" /></div>
            <div className={`mb-3 drop-zone fw-normal ${selectedFiles.length > 0 ? 'active' : ''}`}
              onClick={() => {document.getElementById('filesFormFile').click()}}
              onDragOver={(e) => e.preventDefault()}
              onDrop={handleDrop}>  
                      
              {selectedFiles.length > 0 ? (
                <ul className="list-unstyled mb-0 " style={{ width: '100%', overflowY: 'auto' }}>
                  {selectedFiles.map((selectedFile, index) => (
                    <li style={{ listStyle: 'none' }} key={`${selectedFile.name}-${index}`}>
                    <div className="row file-info" key={`${selectedFile.name}-${index}`}>
                      <div className="file-details">
                        <span className="file-name">{selectedFile.name}</span>
                        <span className="file-size">{(selectedFile.size / 1024).toFixed(2)} KB</span>
                      </div>
                      <img id="removeBtn" src={TrashIcon} alt="Trash Icon" onClick={(e) => removeFile(e, selectedFile)} className={"trash-icon" + (refreshing ? " disabled-image" : "")}/>
                    </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className='color-grey text-center' style={{ textAlign: 'center' }}>
                  <FormattedMessage
                    id="MES_DRAG_AND_DROP_OR_CHOOSE_FILE"
                    values={{
                      chooseFile: (
                        <span
                          className="custom-underline lh-18 fz-16 fw-semibold color-blue "
                          onClick={openFileDialog}
                        >
                          {chooseFileText}
                        </span>
                      ),
                      br: <br />
                    }}
                  />
                </div>
              )}
              <input className="form-control" type="file" ref={fileInputRef} id="filesFormFile" onChange={(e) =>{ handleFileSelection(e.target.files/*[0]*/);}} style={{ display: 'none' }} multiple />
            </div>
            {modalError && (
              <div className="modal-error invalid-feedback d-block fw-bold text-center">
                {modalError}
              </div>
            )}
          </div>
          <div className="modal-footer modal-mes-footer d-flex align-items-center">
            <button id="backBtn" type="button" className="btn btn-outline-secondary me-3" data-bs-dismiss="modal"><FormattedMessage id="CLOSE" /></button>
            <button id="importUsersBtn" type="button" className="btn btn-primary but-darkblue" onClick={handleUpload} disabled={refreshing}>      
              {refreshing ? 
                  <div className="spinner-border" role="status" style={{height: '1rem', width: '1rem'}}/> :
                  <FormattedMessage id="CONTINUE" />
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddFiles;